module.exports = __webpack_public_path__ + "static/logo_pag_cliente-4ab1ee11248d3cb6d9d9ede7856dfa48.svg";